module.exports = __webpack_public_path__ + "img/38.4b37c937.jpg";